module.exports = __webpack_public_path__ + "static/media/Q4.bc0c9d71.png";